import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProfileData } from '../../containers/common/utils/interfaces';

export interface IProfileDataSlice {
  profileData: IProfileData | null;
  getProfileLoading: boolean;
  getProfileError: string | null;
  updatePhoneNumberLoading: boolean;
  updatePhoneNumberError: string | null;
  updateProfilePictureLoading: boolean;
  updateProfilePictureError: string | null;
  fetchedTime: string | null;
}

const initialState: IProfileDataSlice = {
  profileData: null,
  getProfileLoading: false,
  getProfileError: null,
  updatePhoneNumberLoading: false,
  updatePhoneNumberError: null,
  updateProfilePictureLoading: false,
  updateProfilePictureError: null,
  fetchedTime: null
};

export const profileDataSlice = createSlice({
  name: 'profileData',
  initialState,
  reducers: {
    getProfileData: (state) => {
      state.getProfileLoading = true;
    },
    getProfileDataSuccess: (state, action: PayloadAction<IProfileData>) => {
      state.getProfileLoading = false;
      state.profileData = action.payload;
      state.fetchedTime = Date.now().toString();
    },
    getProfileDataFail: (state, action: PayloadAction<string>) => {
      state.getProfileLoading = false;
      state.getProfileError = action.payload;
    },
    updatePhoneNumberStart: (state, action: PayloadAction<IProfileData>) => {
      state.updatePhoneNumberLoading = true;
    },
    updatePhoneNumberSuccess: (state, action: PayloadAction<IProfileData>) => {
      state.updatePhoneNumberLoading = false;
      if (action.payload.mobilePhone && state.profileData) {
        state.profileData.mobilePhone = action.payload.mobilePhone;
      }
    },
    updatePhoneNumberFailed: (state, action: PayloadAction<string>) => {
      state.updatePhoneNumberLoading = false;
      state.updatePhoneNumberError = action.payload;
    },

    updateProfilePictureStart: (state, action: PayloadAction<string>) => {
      state.updateProfilePictureLoading = true;
    },

    updateProfilePictureSuccess: (state, action: PayloadAction<string>) => {
      if (state.profileData) {
        state.profileData.profilePic = '';
      }
      state.updateProfilePictureLoading = false;
    },
    updateProfilePictureFailed: (state, action: PayloadAction<string>) => {
      state.updateProfilePictureLoading = false;
      state.updateProfilePictureError = action.payload;
    }
  }
});

export const { actions: profileDataActions, reducer: profileDataReducer } =
  profileDataSlice;
